import React, { FC } from 'react';
import { faClock } from '@fortawesome/free-solid-svg-icons/faClock';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { gql, useQuery } from '@apollo/client';
import moment from 'moment';

import Skeleton, { SKELETON_WIDTHS } from 'buyside/components/presentation/Skeleton/skeleton';

import styles from '../rankingsIndexPageStyles.scss';

const NextRankingPublishDate: FC = () => {
  const { data, loading } = useQuery(
    gql`
      query {
        nextRankingPublishDate
      }
    `
  );

  const nextRankingPublishDate = data?.nextRankingPublishDate;

  return (
    <span className={styles.nextRankingPublishDate}>
      {loading ? (
        <Skeleton width={SKELETON_WIDTHS.LARGE} />
      ) : (
        <>
          <FontAwesomeIcon icon={faClock} />
          <span>
            Next Update:{' '}
            <strong>{moment(nextRankingPublishDate).format('MMMM D [at] h:mm A')} EST</strong>
          </span>
        </>
      )}
    </span>
  );
};

export default NextRankingPublishDate;
